import { Configuration, PublicClientApplication } from '@azure/msal-browser';

const AUTH_CLIENT_ID: string = import.meta.env.VITE_AUTH_CLIENT_ID || 'NOT_SET';
const AUTH_AUTHORITY_URL: string = import.meta.env.VITE_AUTH_AUTHORITY_URL || 'NOT_SET';

// MSAL configuration
const configuration: Configuration = {
  auth: {
    clientId: AUTH_CLIENT_ID,
    authority: AUTH_AUTHORITY_URL,
    redirectUri: location.origin,
    postLogoutRedirectUri: location.origin,
  },
};

const msalInstance = new PublicClientApplication(configuration);

export default msalInstance;
